import { defineStore } from "pinia";
import { useGetData } from "~/composables/useGetData";
import { usePostData } from "~/composables/usePostData";

export const useColliStore = defineStore("colliStore", {
  state: () => ({
    colli: [],
    caricandoColli: false
  }),
  actions: {
    async getColliOdoo() {
      const { data, getData, loading, messageError } = useGetData();
      this.caricandoColli = true;
      await getData("/api/colli");
      if (!messageError.value) {
        this.colli = data.value;
        this.caricandoColli = loading.value;
      } else {
        //non so cosa fare, johan non ha creato i messaggi di errore qua
        //this.errorMessage = messageError;
      }
    },
    async cambiaStatoColli(body) {
      const {
        data: dataPost,
        postData,
        loading: loadingPost,
        messageError
      } = usePostData();
      await postData("/api/colli/aggiorna_stato_colli", body);
      if (!messageError.value) {
        this.bulkUpdateColli(dataPost.value);
        this.caricandoColli = loadingPost.value;
      }
    },
    // aggiornareElemento (data) {
    //   const { colli } = useColliStore();
    //   for (const collo of data) {
    //     console.log("collo ", collo);
    //     const index = colli.findIndex(({ id }) => id === collo.id);
    //     if (index > -1) {
    //       colli[index].stato_chiave = collo.stato_chiave;
    //       colli[index].stato_nome = collo.stato_nome;
    //       console.log("Aggiornatooooo ", colli[index]);
    //     }
    //   }
    // },
    bulkUpdateColli(updateData) {
      // Create a fast lookup using Uint32Array for better performance
      const maxId = Math.max(...this.colli.map(c => c.id));
      const lookupArray = new Uint32Array(maxId + 1);
      lookupArray.fill(0xFFFFFFFF); // Fill with sentinel value

      // Build lookup table - O(n) operation
      for (let i = 0; i < this.colli.length; i++) {
        lookupArray[this.colli[i].id] = i;
      }

      // Prepare all updates
      const updates = new Map();
      for (const newCollo of updateData.colli) {
        const index = lookupArray[newCollo.id];
        if (index !== 0xFFFFFFFF) {
          updates.set(index, newCollo);
        }
      }

      // Apply all updates in a single batch
      this.$patch((state) => {
        for (const [index, newData] of updates) {
          state.colli[index] = { ...state.colli[index], ...newData };
        }
      });
    }
  }
});
